import React, { useEffect, useState } from 'react';
import { Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { reportingOp } from 'store/ducks/Reportings';
import { RootState } from 'store/configureStore';
import { set_isAdditionalDisplayed } from 'store/ducks/Reportings/reportingSlice';
import { DataCertificates } from 'store/ducks/Reportings/types';
import { certificateColumnsICTSystems } from 'components/Columns/CertificateForICTSystems';

interface reportDataProps {
  entityName: string;
}

const CertificatesByICTSystemsByICTServices: React.FC<reportDataProps> = ({
  entityName,
}) => {
  const { date, is_additional_displayed, ict_system_by_ict_service } =
    useSelector((state: RootState) => state.reportings);
  const [data, setData] = useState<DataCertificates[]>([]);
  const dispatch = useDispatch();

  const fetchData = async () => {
    dispatch(set_isAdditionalDisplayed(false));
    const params = {
      entity_name: entityName,
      ict_system_id: ict_system_by_ict_service,
      date,
    };

    try {
      const fetchedData =
        await reportingOp.fetchCertificatesByICTSystemICTService(params);
      if (fetchedData && Array.isArray(fetchedData.certificates)) {
        const formattedData = fetchedData.certificates.map(
          (dataItem: any, index: number) => ({
            key: index,
            certificate_registry: dataItem.certificate_registry,
            contractual_arrangement_name: dataItem.contractual_arrangement_name,
            date_of_certificate_register: dataItem.date_of_certificate_register,
            date_of_issuance: dataItem.date_of_issuance,
            description: dataItem.certificate_description,
            end_date: dataItem.end_date,
            ict_service_description: dataItem.ict_service_description,
            ict_system_name: dataItem.ict_system_name,
            name_of_entity: dataItem.name_of_entity,
            start_date: dataItem.start_date,
            third_party_provider_name: dataItem.third_party_provider_name,
            validity: dataItem.validity,
          }),
        );

        setData(formattedData);
      } else {
        setData([]);
      }
    } catch (error) {
      console.log('Error fetching branches:', error);
      setData([]);
    }
  };

  useEffect(() => {
    if (ict_system_by_ict_service) {
      fetchData();
    }
  }, [is_additional_displayed, ict_system_by_ict_service]);

  return (
    <>
      <Table
        columns={certificateColumnsICTSystems}
        dataSource={data}
        scroll={{ x: 1000, y: 430 }}
      />
    </>
  );
};

export default CertificatesByICTSystemsByICTServices;
